<script lang="ts">
    import type { Snippet } from 'svelte';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import type { Columns } from '@tilelist/domain/composition/GalleryLayout.ts';

    interface Props {
        columns?: Columns;
        children: Snippet;
    }

    let { columns, children }: Props = $props();

    const onex = injectWiring().onex;
    const visualRefreshActive = $derived(onex.isExperimentGroup('VISUAL_REFRESH', 'E3933B'));
</script>

<!-- Product-List-level dispatch point (ADRs 0016-0018 leave this placement open). Carries the
     E3933B difference via a modifier class instead of a forked sibling component. -->
<section
    class={[
        'reptile-tile-list',
        {
            'reptile-tile-list--visual-refresh': visualRefreshActive,
            [`reptile-tile-list__column--${columns}`]: columns,
        },
    ]}
>
    {@render children()}
</section>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@otto-ec/otto-components-utils/scss/mixins';

    .reptile-tile-list {
        position: relative;

        display: grid;
        grid-auto-rows: minmax(0, min-content);
        gap: tokens.$oc-semantic-spacing-absolute-25;

        margin: tokens.$oc-semantic-spacing-absolute-25;

        @include mixins.breakpoint-from-l($to: false, $containerFirst: false) {
            gap: tokens.$oc-semantic-spacing-absolute-50;
            margin: tokens.$oc-semantic-spacing-absolute-50 tokens.$oc-semantic-spacing-absolute-50
                tokens.$oc-semantic-spacing-absolute-50 tokens.$oc-semantic-spacing-absolute-25;
        }

        /*                                                                                                  */
        &--visual-refresh {
            gap: tokens.$oc-semantic-spacing-absolute-150 tokens.$oc-semantic-spacing-absolute-12;
            margin: 0;

            @include mixins.breakpoint-from-l($to: false, $containerFirst: false) {
                gap: tokens.$oc-semantic-spacing-absolute-150 tokens.$oc-semantic-spacing-absolute-12;
                margin: 0;
            }

            /*                                                                                                            */
            :global(.reptile-sda-hoarding--list-slot),
            :global(.reptile-similar-products__header),
            :global(.reptile-span-grid),
            :global(.reptile-benefit-cinema) {
                margin-block: calc(-1 * #{tokens.$oc-semantic-spacing-absolute-150});
            }
        }

        &__column {
            &--one-two {
                grid-template-columns: minmax(0, 1fr);

                @include mixins.breakpoint-from-l($to: false, $containerFirst: false) {
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                }
            }

            &--two-three {
                /*                                                               */
                grid-template-columns: repeat(2, minmax(0, 1fr));

                @include mixins.breakpoint-from-l($to: false, $containerFirst: false) {
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                }
            }
        }
    }
</style>
